import React, { useState } from "react";
import { Modal, Image } from "react-bootstrap";

/**
 * Componente immagine cliccabile con visualizzazione full screen in modale.
 */
const ClickableImageWithModal = ({ src, alt = "image", style }) => {
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <>
      <Image
        src={src}
        alt={alt}
        onClick={handleOpen}
        style={{ cursor: "pointer", ...style }}
      />

      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        size="lg"
        aria-labelledby="image-preview-modal"
        className="image-preview-modal"
      >
        <Modal.Body style={{ padding: 0 }} onClick={handleClose}>
          <div className="p-2">
            <Image
              src={src}
              alt={alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: 5,
              }}
              fluid
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ClickableImageWithModal;
